import './xmas-effect.css';
import './snow-cap.css';

export function XmasEffect({ snow, sleign }: { snow?: boolean; sleign?: boolean }) {
  return (
    <div className='hidden sm:block xmas-container bg-brand-secondary flex inset-0 pointer-events-none max-w-10xl overflow-hidden'>
      {snow && (
        <section className='sleigh '>
          <div className='santa'>🦌</div>
          <div className='santa1'>🦌</div>
          <div className='santa2'>🦌</div>
          <div className='santa3'>🦌</div>
          <div className='santa4'>🦌</div>
          <div className='santa5'>🦌</div>
          <div className='santa6'>
            <i className='fa-solid fa-sleigh'></i>
          </div>
        </section>
      )}
      {sleign && (
        <section className='snow'>
          <div className='snowflake'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake1'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake2'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake3'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake4'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake5'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake6'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake7'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake8'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake9'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake10'>
            <i className='fa-solid fa-snowflake'></i>
          </div>
          <div className='snowflake11'>
            <i className='fa-solid fa-snowflake'></i>
          </div>
          <div className='snowflake12'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake13'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
          <div className='snowflake14'>
            <i className='fa-regular fa-snowflake'></i>
          </div>
        </section>
      )}
    </div>
  );
}
